import script from "./Pagination.vue?vue&type=script&setup=true&lang=js"
export * from "./Pagination.vue?vue&type=script&setup=true&lang=js"

import "./Pagination.vue?vue&type=style&index=0&id=e178d3f6&scoped=true&lang=scss"
script.__scopeId = "data-v-e178d3f6"

export default script